// Legacy CorrMonitor (assetView) now lives at /CorrMonitorOld.
// The /CorrMonitor path is served by the new page at
// src/main/components/pages/CorrMonitor/CorrMonitorPage.jsx
export const rootPath = '/CorrMonitorOld';
export const path = `${rootPath}/:zoom?/:lat?/:lon?/:groupName?/:assetType?/:assetId?`;

export const fallbackRootPath = '/AssetView';
export const fallbackPath = `${rootPath}/:zoom?/:lat?/:lon?/:groupName?/:assetType?/:assetId?`;
